import React from 'react';

const Spacer = (props) => {
    return (<>
        <section className={`section spacer ${props.bgClass}`}>
            <div className="container py-5">
                <div className="row">
                    <div className="col-md-12">
                    </div>
                </div>
            </div>
        </section>
    </>)
}

export default Spacer;